import { DeserializedApplication, NumberPartition, StringPartition } from '@amzn/awscat-portfolio-assessment-types';

import { ColumnDefinition } from '../../../common/table/types';
import { MAX_NUMBER_OF_DISTINCT_VALUES } from './constants';

interface AttributeValuesMap {
    numeric: boolean;
    uniqueValues: {
        [value: string]: number;
    };
    min?: number;
    max?: number;
}
export const getUniqueAttributeValues = (header: ColumnDefinition<DeserializedApplication>, applications: DeserializedApplication[]): AttributeValuesMap => {
    const uniqueAttributeValues: AttributeValuesMap = {uniqueValues: {}, numeric: true};

    // if all values are numeric values, output a range with min and max; otherwise output key-value pairs
    applications.forEach(app => {
        const val = app[header.id as keyof DeserializedApplication];
        if (val === null || val === '') return;
        if (isNaN(val as any)) {
            uniqueAttributeValues.numeric = false;
        }
       
        const strVal = (`${val}`).toLowerCase();
        (uniqueAttributeValues.uniqueValues as any)[strVal] = (uniqueAttributeValues.uniqueValues as any)[strVal] + 1 || 1;
    });

    //set default to alphanumeric when there is no valid value
    if (Object.keys(uniqueAttributeValues.uniqueValues).length === 0) {
        uniqueAttributeValues.numeric = false;
    }

    if (uniqueAttributeValues.numeric) {
        uniqueAttributeValues.max = Math.max(...Object.keys(uniqueAttributeValues.uniqueValues).map(num => Number(num)));
        uniqueAttributeValues.min = Math.min(...Object.keys(uniqueAttributeValues.uniqueValues).map(num => Number(num)));
    }

    if (uniqueAttributeValues.max == null || uniqueAttributeValues.min == null || isNaN(uniqueAttributeValues.max) || isNaN(uniqueAttributeValues.min)) {
        uniqueAttributeValues.numeric = false;
    }
    return uniqueAttributeValues;
};

export const buildAttributePartitionFromValues = 
(col: ColumnDefinition<DeserializedApplication>, uniqueAttributeValues: AttributeValuesMap): StringPartition | NumberPartition => {
    // in case of numeric range, assign three ranges, use min and max values as upper bounds (two ranges if min equals to max)
    if (uniqueAttributeValues.numeric) {
        let upperBounds: string[] = [];
        let labels: string[] = [];
        let rangeOutputs: number[] = [];
        const min = uniqueAttributeValues.min;
        const max = uniqueAttributeValues.max;
        if (min == null || max == null) {
            return {
                labels: labels,
                upperBounds: upperBounds,
                rangeOutputs: rangeOutputs
            };
        }
        if (min < max) {
            upperBounds = [`${min}`, `${max}`];
            labels = [`<= ${min}`, `${min} < ${col.text} <= ${max}`, `> ${max}`];
            rangeOutputs = [0, 0, 0];
        } else {
            upperBounds = [`${min}`];
            labels = [`<= ${min}`, `> ${min}`];
            rangeOutputs = [0, 0];
        }

        return {
            labels: labels,
            upperBounds: upperBounds,
            rangeOutputs: rangeOutputs
        };
    }
    // in case of alphanumeric key value pair
    else {
        let numOfValuesExceedsLimit = false;

        if (Object.keys(uniqueAttributeValues.uniqueValues).length > MAX_NUMBER_OF_DISTINCT_VALUES) {
            numOfValuesExceedsLimit = true;
        }
        const items = Object.keys(uniqueAttributeValues.uniqueValues)
            .slice(0, MAX_NUMBER_OF_DISTINCT_VALUES)
            .map(uniqueVal => ({
                key: uniqueVal,
                value: 0
            }));
        return {
            items: items,
            numOfValuesExceedsLimit: numOfValuesExceedsLimit,
        };
    }
};
